import React from 'react'

const CalculatorColumnBottomRight = (props) => {
    return (
        <div className='calculator-box__column-bottom-right'>
            {props.children}
        </div>
    )
}

export default CalculatorColumnBottomRight